import { render, staticRenderFns } from "./direccionesSoporteData.vue?vue&type=template&id=33d1203a&scoped=true&"
import script from "./direccionesSoporteData.vue?vue&type=script&lang=js&"
export * from "./direccionesSoporteData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d1203a",
  null
  
)

export default component.exports